<div class="mt-3 side-menu-back">
  <app-side-menu-default-button *ngFor="let item of ctx.ShopModuleMenu.MenuItems" [menuItem]="item"></app-side-menu-default-button>
</div>
